// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"853":"12fab00b0dd5c8d7","7945":"ca177f842233f043"}[chunkId] + ".css";
};